import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { debounce } from 'lodash'
import { useConfigUI } from '../../context'
import useDeleteReference from '../../hooks/etReference/useDeleteReference'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
  name?: string
  onSuccess?: () => void
}

const DeleteReferenceModal = ({
  id,
  interfaceId,
  name,
  onSuccess,
}: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()

  const { mutate: deleteModal, isLoading: loadingDeleteReference } =
    useDeleteReference()

  const handleDeleteReference = debounce(async () => {
    if (!id) return
    if (!interfaceId) return
    deleteModal(
      { interfaceId, id },
      {
        onSuccess: () => {
          onSuccess && onSuccess()
        },
      },
    )
  }, 300)

  return (
    <ConfirmDeleteModalUI
      title={t('DeleteETReference')}
      name={name}
      text={t('ETReferenceDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteReference}
      isLoading={loadingDeleteReference}
    />
  )
}

export default DeleteReferenceModal
